import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/internal/Observable';
import {BehaviorSubject} from 'rxjs/internal/BehaviorSubject';
import {ServerAuthService, UserLoginModel} from './server-auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  currentUser: Observable<UserLoginModel>;
  loginState: Observable<boolean>;

  private currentUserSubject: BehaviorSubject<UserLoginModel>;
  private loginStateSubject: BehaviorSubject<boolean>;
  private KEY_USER = 'KEY_USER';

  constructor(private loginService: ServerAuthService) {
    const user = JSON.parse(localStorage.getItem(this.KEY_USER) || '{}');

    this.currentUserSubject = new BehaviorSubject<UserLoginModel>(user);
    this.loginStateSubject = new BehaviorSubject<boolean>(!!user);

    this.currentUser = this.currentUserSubject.asObservable();
    this.loginState = this.loginStateSubject.asObservable();
  }

  get currentUserValue(): UserLoginModel {
    return this.currentUserSubject.value;
  }

  get isLogggedIn(): boolean {
    return this.loginStateSubject.value;
  }

  login(userLoginModel: UserLoginModel) {
    localStorage.setItem(this.KEY_USER, JSON.stringify(userLoginModel));
    this.currentUserSubject.next(userLoginModel);
    this.loginStateSubject.next(true);
  }

  logout() {
    localStorage.removeItem(this.KEY_USER);
    this.currentUserSubject.next({} as UserLoginModel);
    this.loginStateSubject.next(false as boolean);
    location.reload();
  }

   retrieveToken(): string {
    return localStorage.getItem(this.KEY_USER) || "{}";
  }

  private saveToken(token: string) {
    localStorage.setItem(this.KEY_USER, token);
  }
}
